<div layout="row" layout-wrap="false" flex-align="start">
	@if (showExpander) {
		<button type="button" [attr.aria-pressed]="!isCollapsed" [attr.aria-label]="'UI_CollapsableSection_Expand' | translate" class="expanderBtn" (click)="onExpanderClick()">
			<span class="glyphicons chevron-right" [class.expanderIconExpanded]="!isCollapsed"></span>
		</button>
	}

	@if (showGroupCheckbox) {
		<vb-ui-checkbox flex="1 1 0" [mixedStateEnabled]="true" class="groupCheckbox" [(ngModel)]="isGroupChecked" (touched)="onTouched()">
			{{ groupLabel }}
		</vb-ui-checkbox>
	}
</div>

<ul class="list" [hidden]="isCollapsed" [class.listWithExpander]="showExpander" ngForm="checkGroup">
	@for (option of internalModel; track option) {
		<li class="listItem" [hidden]="option.isHidden">
			<vb-ui-checkbox class="checkbox" [disabled]="isDisabled" [name]="option.id" [accessibilityLabel]="option.label" [(ngModel)]="option.isChecked" (touched)="onTouched()">
				<span [innerHTML]="option.label | highlight : highlightMatch : 'highlight'">
				</span>
			</vb-ui-checkbox>
		</li>
	}
</ul>
